import usePollingLogChunks from '@/hooks/usePollingLogChunks';

const useLog = ({ buildSlug, appSlug }: { buildSlug: string | undefined; appSlug: string }) =>
  usePollingLogChunks({
    url: `/v0.1/apps/${appSlug}/builds/${buildSlug}/log`,
    queryKey: ['apps', appSlug, 'builds', buildSlug, 'log'],
    enabled: Boolean(buildSlug),
  });

export default useLog;
